import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import React, {Component} from 'react';
import {Col, Grid, Row} from 'react-bootstrap'
import moment from "moment/moment";

const sGroups = [
    "person_read",
    "membership_read"
];

const yearOptions = (() => {
    const currentYear = moment().year();
    let startYear = 2018;
    let years = [startYear];

    while (startYear < currentYear) {
        const year = startYear + 1;
        years.push(year)
        startYear++;
    }
    return years;
})();

const reportsConfig = (year) => {
    const yearEnd = moment(year, 'YYYY').endOf('year').toISOString();

    return [
        {
            key: 'allMembers',
            loadingKey: 'allMembersLoading',
            title: 'Todos los miembros',
            filename: 'Miembros',
            filter: {
                'membership[exists]': true,
                //'dateOfDeath[exists]': false,
                'membership.registrationDate[before]': yearEnd
            }
        },
        {
            key: 'founderMembers',
            loadingKey: 'founderMembersLoading',
            title: 'Miembros fundadores',
            filename: 'Miembros fundadores',
            filter: {
                'membership.type': 'Miembro fundador',
                'membership.registrationDate[before]': yearEnd
            }
        },
        {
            key: 'activeMembers',
            loadingKey: 'activeMembersLoading',
            title: 'Miembros activos',
            filename: 'Miembros activos',
            filter: {
                'membership.annuityPayments.type': "membership",
                'membership.annuityPayments.year': year,
                //'dateOfDeath[exists]': false,
                'membership.registrationDate[before]': yearEnd
            }
        },
        {
            key: 'inactiveMembers',
            loadingKey: 'inactiveMembersLoading',
            title: 'Miembros inactivos',
            filename: 'Miembros inactivos',
            filter: {
                'not_membership': year + ",membership",
                //'dateOfDeath[exists]': false,
                'membership.registrationDate[before]': yearEnd
            }
        },
        {
            key: 'activeIhsMembers',
            loadingKey: 'activeIhsMembersLoading',
            title: 'Miembros IHS activos',
            filename: 'Miembros IHS activos',
            filter: {
                'membership.annuityPayments.type': "ihs",
                'membership.annuityPayments.year': year,
                //'dateOfDeath[exists]': false,
                'membership.registrationDate[before]': yearEnd
            }
        },
        {
            key: 'inactiveIhsMembers',
            loadingKey: 'inactiveIhsMembersLoading',
            title: 'Miembros IHS inactivos',
            filename: 'Miembros IHS inactivos',
            filter: {
                'not_membership': year + ",ihs",
                //'dateOfDeath[exists]': false,
                'membership.registrationDate[before]': yearEnd
            }
        },
    ]
}

class MembersReports extends Component {
    static contextTypes = {api: PropTypes.object};


    allMembers = 'allMembers';
    founderMembersLoading = 'foundersLoading';
    activeMembersLoading = 'activeLoading';
    inactiveMembersLoading = 'inactiveMembersLoading';
    activeIhsMembersLoading = 'activeIhsMembersLoading';
    inactiveIhsMembersLoading = 'inactiveIhsMembersLoading';

    constructor(props, context) {
        super(props);
        this.context = context;
        this.state = {
            currentYear: moment().year()
        };
    }

    componentDidMount() {
        this.fetchData();
    }

    //on state change
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.currentYear !== this.state.currentYear) {
            this.fetchData();
        }
    }

    handleYearChange = (e) => {
        this.setState({currentYear: e.target.value})
    }

    fetchData = () => {
        const currentYear = this.state.currentYear;
        reportsConfig(currentYear).forEach(config => {
            this.context.api.people.get(0, 0, '', {
                ...config.filter,
                sGroups,
            }, config.key, config.loadingKey);
        });
    }

    loadData = (tableState) => {
        this.tableState = tableState;
        if (tableState.filters.tags) tableState.filters['mailerTags.name'] = tableState.filters.tags;

        const filters = {...tableState.filters, 'order[name]': 'DESC'};
        this.context.api.emailAddresses.get(tableState.page, tableState.pageSize, '@Class.EmailAddresses.emailAddresses.get', filters)
    };


    render() {
        const {currentYear} = this.state;

        return (
            <div className="container-fluid MembersReports">
                <select
                    className={'annuityPaymentYear'}
                    name="annuityPaymentYear"
                    onChange={this.handleYearChange}
                    value={currentYear}
                >
                    {yearOptions.map((y, index) => <option key={index} value={y}>{y}</option>)}
                </select>

                <Grid fluid>
                    <Row>
                        {reportsConfig(currentYear).map((report, index) => {
                            const {title, key} = report;
                            const metaData = this.props[`${key}Meta`];
                            const filters = report.filter;

                            if((title === "Miembros IHS inactivos" || title === "Miembros IHS activos")&& currentYear==="2018" )
                                return;

                            return (
                                <Col key={index} lg={6} md={6} sm={6} xs={12}>
                                    <div className='reportCard'>
                                        <h4>{title}</h4>
                                        <p className='stat-number'>{metaData.totalItems}</p>
                                        <p className='downloadLink'><a
                                            href={this.context.api.people.exportUrl(filters, true, 'xlsx', `${title} ${currentYear}`)}>Descargar
                                            excel</a></p>
                                        <p className='downloadLink'><a
                                            href={this.context.api.people.exportUrl(filters, true, 'pdf', `${title} ${currentYear}`)}>Descargar
                                            PDF</a></p>
                                    </div>
                                </Col>
                            );
                        })}
                    </Row>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = ({
                             api: {
                                 founderMembers = [],
                                 founderMembersMeta = {},
                                 inactiveMembers = [],
                                 inactiveMembersMeta = {},
                                 activeMembers = [],
                                 activeMembersMeta = {},
                                 inactiveIhsMembers = [],
                                 inactiveIhsMembersMeta = {},
                                 activeIhsMembers = [],
                                 activeIhsMembersMeta = {},
                                 allMembers = [],
                                 allMembersMeta = {}

                             }
                         }) => {
    return {
        founderMembers,
        founderMembersMeta,
        inactiveMembers,
        inactiveMembersMeta,
        activeMembers,
        activeMembersMeta,
        inactiveIhsMembers,
        inactiveIhsMembersMeta,
        activeIhsMembers,
        activeIhsMembersMeta,
        allMembers,
        allMembersMeta
    }
};

export default connect(mapStateToProps)(MembersReports);




// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/Reports/MembersReports/index.jsx